import React from 'react';
import LoadingBounce from './LoadingBounce';

export default function Callback() {
  return <LoadingBounce style={{ marginTop: '50vh' }} />;
}
